import PriceFilter from './PriceFilter.jsx';
import CheckBoxFilter from './CheckBoxFilter.jsx';

export {
  PriceFilter,
  CheckBoxFilter
}


// WEBPACK FOOTER //
// ./components/list-product/list-filter/sub-filter/index.js